module.exports = __webpack_public_path__ + "static/media/rio_oswaldocruz.e884cac3.png";